import React from 'react';

const Modal = ({ show, handleClose, isSubscribed, isLoggedIn, children }) => {
    const handleLoginSignupClick = () => {
        const targetUrl = isLoggedIn ? "/subscription" : "/login"; 
        window.location.href = targetUrl;
    };

    return (
        <div className={`modal ${show ? 'show d-block' : 'd-none'}`} tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title text-black">
                            {isLoggedIn 
                                ? isSubscribed 
                                    ? "Action Required" 
                                    : "🔓 Unlock downloads " 
                                : "Login Required"}
                        </h5>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-black">
                                        {/*children*/}                                                                                                                                                                                         

                        {/* Redirection to either subscribe or login */}
                        <div 
                            className="text-decoration-underline text-primary mt-3" 
                            style={{ cursor: 'pointer' }} 
                            onClick={handleLoginSignupClick}
                        >
                            {isLoggedIn 
                                ? isSubscribed 
                                    ? null 
                                    : <button className="btn btn-primary px-4 py-2 rounded-pill shadow-sm fw-semibold"  type="button">Unlock downloads</button> 
                                : <button className="btn btn-primary px-4 py-2 rounded-pill shadow-sm fw-semibold"  type="button">Login to continue</button>}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>                                                                                              
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
